import React, { useState } from "react";
import {
  Form,
  Input,
  DatePicker,
  Table,
  InputNumber,
  Select,
  Upload,
  Button,
  Row,
  Col,
  Card,
  message,
  notification,
  Checkbox,
  Popover,
  Spin,
  Tag,
} from "antd";
import {
  PlusOutlined,
  UploadOutlined,
  DeleteOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import ApprovalButtons from "../Forms/ApprovalButtons";
import RequestHandler from "../../util/RequestHandler";
import { odata } from "../Filters/Helper";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import moment from "moment";
import { Typography } from "antd";
import config from "../../util/ApiforContext";
import { useLocation } from "react-router-dom";

const { Title, Text } = Typography;
const { Option } = Select;

const UpdatePurchaseRequest = (props) => {
  const [form] = Form.useForm();
  const history = useHistory();
  const [materialsData, setMaterialsData] = useState({
    data: [],
    loading: false,
  });
  const [rows, setRows] = useState([]);
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [existingFiles, setExistingFiles] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const mode = queryParams.get("mode") || "edit";
  const isViewMode = mode === "view";
  const [tenantName, setTenantName] = useState("");
  const [firmTransactionProjectTypeList, setFirmTransactionProjectTypeList] =
    useState({
      data: [],
      loading: false,
    });

  const [firmSelected, setFirmSelected] = useState(false);
  const [data, setData] = useState({});
  const [initialRowsSet, setInitialRowsSet] = useState(false);
  const [categoryFilled, setCategoryFilled] = useState(false);
  const [stockWarehouseMap, setStockWarehouseMap] = useState({});

  const fetchStockWarehouseData = (stockId) => {
    if (!stockId || stockWarehouseMap[stockId]) return;
    setStockWarehouseMap((prev) => ({ ...prev, [stockId]: { loading: true, data: [] } }));
    RequestHandler.get(`/PurchaseRequest/GetStockWarehouseByStockId/${stockId}`).then((res) => {
      setStockWarehouseMap((prev) => ({
        ...prev,
        [stockId]: { loading: false, data: res || [] },
      }));
    });
  };

  const getCategoryAncestors = (categoryId, categories) => {
    const result = [];
    let current = categories.find((c) => c.id === categoryId);
    while (current) {
      result.unshift(current);
      current = current.parentId
        ? categories.find((c) => c.id === current.parentId)
        : null;
    }
    return result;
  };

  const getDescendantIds = (categoryId, categories) => {
    const ids = [categoryId];
    const children = categories.filter((c) => c.parentId === categoryId);
    children.forEach((child) => {
      ids.push(...getDescendantIds(child.id, categories));
    });
    return ids;
  };

  const getCategoryChildren = (parentId, categories) => {
    if (!parentId) {
      return categories.filter((c) => !c.parentId);
    }
    return categories.filter((c) => c.parentId === parentId);
  };

  useEffect(() => {
    if (props.match.params.id) {
      RequestHandler.get(
        `/PurchaseRequest/GetById/${props.match.params.id}`,
      ).then((response) => {
        if (!response) {
          message.error("Talep verileri alınamadı.");
          return;
        }

        const data = response;
        setData(response);

        form.setFieldsValue({
          name: data?.name,
          description: data?.description,
          desiredDeliveryDate: data?.desiredDeliveryDate
            ? moment(data?.desiredDeliveryDate)
            : null,
          id: data?.id,
          firmId: data?.firmId || null,
          detailedDescription: data?.detailedDescription,
          purposeOfPurchasing: data?.purposeOfPurchasing,
          transactionProjectTypeId: data?.transactionProjectTypeId || null,
        });

        setRows(
          (data.purchaseRequestItems || []).map((item) => ({
            ...item,
            key: item.id || Date.now() + Math.random(),
            cat1Id: null,
            cat2Id: null,
            cat3Id: null,
            cat4Id: null,
            cat5Id: null,
          })),
        );
        setInitialRowsSet(true);

        setExistingFiles(data.files || []);

        if (data?.firmId) {
          RequestHandler.get(
            `/PurchaseRequest/GetByFirmId/${data?.firmId}`,
          ).then((firm) => {
            if (firm) {
              setFirmSelect({
                data: [firm],
                loading: false,
              });
            }
          });
        }

        const stockIds = (data.purchaseRequestItems || [])
          .map((item) => item.stockId)
          .filter(Boolean);

        if (stockIds.length > 0) {
          const filter = `id in (${stockIds.map((id) => `'${id}'`).join(",")})`;

          RequestHandler.get(
            `/PurchaseRequest/GetStockList?$filter=${encodeURIComponent(
              filter,
            )}`,
          ).then((stockResponse) => {
            if (stockResponse) {
              setMaterialsData({
                data: stockResponse || [],
                loading: false,
              });
            } else {
              setMaterialsData({ data: [], loading: false });
            }
          });
        } else {
          setMaterialsData({ data: [], loading: false });
        }

        if (data?.firmId) {
          setFirmSelected(true);
          RequestHandler.get(
            `/FirmTransactionProjectType/GetListByFirmId/${data?.firmId}`,
          ).then((res) => {
            setFirmTransactionProjectTypeList({
              data: res || [],
              loading: false,
            });
          });
        }
      });
    } else {
      notification.warning({
        message: "Uyarı",
        description: "Güncelleme için geçerli bir talep kaydı bulunamadı.",
      });
    }
  }, [props.match.params.id]);

  useEffect(() => {
    RequestHandler.get(`/MaterialCategory?$top=10000`).then((response) => {
      setAllCategories(response?.value || []);
    });
  }, []);

  useEffect(() => {
    RequestHandler.get(
      `/Tenant/GetById/${localStorage.getItem("tenantId")}`,
    ).then((res) => {
      setTenantName(res?.name);
    });
  }, []);

  useEffect(() => {
    if (initialRowsSet) {
      rows.forEach((row) => {
        if (row.stockId) fetchStockWarehouseData(row.stockId);
      });
    }
  }, [initialRowsSet]);

  useEffect(() => {
    if (allCategories.length > 0 && initialRowsSet && !categoryFilled) {
      setCategoryFilled(true);
      setRows((prev) =>
        prev.map((row) => {
          if (row.materialCategoryId) {
            const ancestors = getCategoryAncestors(
              row.materialCategoryId,
              allCategories,
            );
            return {
              ...row,
              cat1Id: ancestors[0]?.id || null,
              cat2Id: ancestors[1]?.id || null,
              cat3Id: ancestors[2]?.id || null,
              cat4Id: ancestors[3]?.id || null,
              cat5Id: ancestors[4]?.id || null,
            };
          }
          return row;
        }),
      );
    }
  }, [allCategories, initialRowsSet, categoryFilled]);

  const addRow = () => {
    setRows([
      ...rows,
      {
        key: Date.now(),
        quantity: null,
        unit: "",
        name: "",
        stockCode: "",
        stockId: null,
        materialCategoryId: null,
        cat1Id: null,
        cat2Id: null,
        cat3Id: null,
        cat4Id: null,
        cat5Id: null,
      },
    ]);
  };

  const updateRow = (key, field, value) => {
    setRows((prev) =>
      prev.map((row) => {
        if (row.key === key) {
          const updatedRow = { ...row, [field]: value };

          if (field === "stockId") {
            if (value) {
              const selected = materialsData.data.find((m) => m.id === value);
              if (selected) {
                updatedRow.name = selected.name;
                updatedRow.stockCode = selected.stockCode;
                updatedRow.unit = selected.unit || "";
                updatedRow.materialCategoryId =
                  selected.materialCategoryId || null;
                fetchStockWarehouseData(value);

                if (selected.materialCategoryId && allCategories.length > 0) {
                  const ancestors = getCategoryAncestors(
                    selected.materialCategoryId,
                    allCategories,
                  );
                  updatedRow.cat1Id = ancestors[0]?.id || null;
                  updatedRow.cat2Id = ancestors[1]?.id || null;
                  updatedRow.cat3Id = ancestors[2]?.id || null;
                  updatedRow.cat4Id = ancestors[3]?.id || null;
                  updatedRow.cat5Id = ancestors[4]?.id || null;
                }
              }
            } else {
              updatedRow.materialCategoryId = null;
              updatedRow.cat1Id = null;
              updatedRow.cat2Id = null;
              updatedRow.cat3Id = null;
              updatedRow.cat4Id = null;
              updatedRow.cat5Id = null;
            }
          }

          if (field === "cat1Id") {
            updatedRow.cat2Id = null;
            updatedRow.cat3Id = null;
            updatedRow.cat4Id = null;
            updatedRow.cat5Id = null;
          }
          if (field === "cat2Id") {
            updatedRow.cat3Id = null;
            updatedRow.cat4Id = null;
            updatedRow.cat5Id = null;
          }
          if (field === "cat3Id") {
            updatedRow.cat4Id = null;
            updatedRow.cat5Id = null;
          }
          if (field === "cat4Id") {
            updatedRow.cat5Id = null;
          }

          return updatedRow;
        }
        return row;
      }),
    );
  };

  const deleteRow = (key) => {
    setRows((prev) => prev.filter((row) => row.key !== key));
  };

  const columns = [
    {
      title: "Kategori 1",
      dataIndex: "cat1Id",
      width: 150,
      render: (value, record) => (
        <Select
          placeholder="Kategori 1"
          value={value}
          allowClear
          showSearch
          onChange={(val) => updateRow(record.key, "cat1Id", val)}
          style={{ width: 150 }}
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
          disabled={isViewMode}
        >
          {getCategoryChildren(null, allCategories).map((c) => (
            <Option key={c.id} value={c.id}>
              {c.name}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Kategori 2",
      dataIndex: "cat2Id",
      width: 150,
      render: (value, record) => {
        const options = record.cat1Id
          ? getCategoryChildren(record.cat1Id, allCategories)
          : [];
        return (
          <Select
            placeholder="Kategori 2"
            value={value}
            allowClear
            showSearch
            onChange={(val) => updateRow(record.key, "cat2Id", val)}
            style={{ width: 150 }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
            disabled={isViewMode || !record.cat1Id}
          >
            {options.map((c) => (
              <Option key={c.id} value={c.id}>
                {c.name}
              </Option>
            ))}
          </Select>
        );
      },
    },
    {
      title: "Kategori 3",
      dataIndex: "cat3Id",
      width: 150,
      render: (value, record) => {
        const options = record.cat2Id
          ? getCategoryChildren(record.cat2Id, allCategories)
          : [];
        return (
          <Select
            placeholder="Kategori 3"
            value={value}
            allowClear
            showSearch
            onChange={(val) => updateRow(record.key, "cat3Id", val)}
            style={{ width: 150 }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
            disabled={isViewMode || !record.cat2Id}
          >
            {options.map((c) => (
              <Option key={c.id} value={c.id}>
                {c.name}
              </Option>
            ))}
          </Select>
        );
      },
    },
    {
      title: "Kategori 4",
      dataIndex: "cat4Id",
      width: 150,
      render: (value, record) => {
        const options = record.cat3Id
          ? getCategoryChildren(record.cat3Id, allCategories)
          : [];
        return (
          <Select
            placeholder="Kategori 4"
            value={value}
            allowClear
            showSearch
            onChange={(val) => updateRow(record.key, "cat4Id", val)}
            style={{ width: 150 }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
            disabled={isViewMode || !record.cat3Id}
          >
            {options.map((c) => (
              <Option key={c.id} value={c.id}>
                {c.name}
              </Option>
            ))}
          </Select>
        );
      },
    },
    {
      title: "Kategori 5",
      dataIndex: "cat5Id",
      width: 150,
      render: (value, record) => {
        const options = record.cat4Id
          ? getCategoryChildren(record.cat4Id, allCategories)
          : [];
        return (
          <Select
            placeholder="Kategori 5"
            value={value}
            allowClear
            showSearch
            onChange={(val) => updateRow(record.key, "cat5Id", val)}
            style={{ width: 150 }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
            disabled={isViewMode || !record.cat4Id}
          >
            {options.map((c) => (
              <Option key={c.id} value={c.id}>
                {c.name}
              </Option>
            ))}
          </Select>
        );
      },
    },
    {
      title: "Malzeme",
      dataIndex: "stockId",
      render: (value, record) => (
        <Select
          placeholder="(Opsiyonel). En az 2 harf giriniz.."
          value={value}
          allowClear
          showSearch
          onSearch={(val) => onMaterialSearch(val, record)}
          onChange={(val) => updateRow(record.key, "stockId", val)}
          style={{ width: "100%" }}
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
            option.code
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
          disabled={isViewMode}
        >
          {materialsData?.data?.map((m) => (
            <Option key={m.id} value={m.id}>
              {m.name}
            </Option>
          ))}
        </Select>
      ),
    },
    {
      title: "Stok Kodu",
      dataIndex: "stockCode",
      render: (value, record) => (
        <Input
          value={value}
          readOnly={true}
          disabled={isViewMode}
        />
      ),
    },
    {
      title: "Miktar",
      dataIndex: "quantity",
      render: (value, record) => (
        <InputNumber
          min={0}
          value={value}
          onChange={(val) => updateRow(record.key, "quantity", val)}
          disabled={isViewMode}
        />
      ),
    },
    {
      title: "Birim",
      dataIndex: "unit",
      render: (value, record) => (
        <Input
          value={value}
          readOnly={true}
          disabled={isViewMode}
        />
      ),
    },
    {
      title: "Mevcut Stok",
      dataIndex: "stockId",
      key: "stockInfo",
      width: 120,
      render: (stockId) => {
        if (!stockId) return null;
        const info = stockWarehouseMap[stockId];
        if (!info) return null;
        if (info.loading) return <Spin size="small" />;
        if (!info.data || info.data.length === 0)
          return <Tag color="orange">Stok Yok</Tag>;
        const totalCount = info.data.reduce(
          (sum, w) => sum + (w.count || 0),
          0,
        );
        const content = (
          <div>
            {info.data.map((w) => (
              <div
                key={w.id}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: 16,
                  padding: "4px 0",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <span>{w.name || w.projectCode || "Depo"}</span>
                <strong>{w.count}</strong>
              </div>
            ))}
          </div>
        );
        return (
          <Popover
            content={content}
            title="Depo Bazlı Stok"
            trigger="click"
          >
            <Tag
              color="blue"
              style={{ cursor: "pointer" }}
            >
              <InfoCircleOutlined /> {totalCount}
            </Tag>
          </Popover>
        );
      },
    },
    {
      title: "Sil",
      key: "action",
      render: (_, record) => (
        <Button
          danger
          type="link"
          icon={<DeleteOutlined />}
          onClick={() => deleteRow(record.key)}
          disabled={isViewMode}
        ></Button>
      ),
    },
  ];

  const onSuccess = () => {
    form.resetFields();
    setFiles([]);
    setTimeout(
      function () {
        history.push(`/purchase-request-list`);
      }.bind(this),
      2000,
    );
  };

  const onFinish = (values) => {
    const stockCounts = {};
    const duplicateRows = [];

    rows.forEach((row) => {
      if (row.stockId) {
        stockCounts[row.stockId] = (stockCounts[row.stockId] || 0) + 1;

        if (stockCounts[row.stockId] === 2) {
          duplicateRows.push(row);
        }
      }
    });

    if (duplicateRows.length > 0) {
      duplicateRows.forEach((row) => {
        setLoading(false);
        notification.error({
          message: "Mükerrer Ürün",
          description: `${row.name} malzemesi listede birden çok bulunuyor. Lütfen kontrol ediniz.`,
          placement: "topRight",
        });
      });
      return;
    }

    const invalidRows = rows.filter((row) => {
      const hasMaterial = row.stockId || (row.name && row.name.trim() !== "");
      const validQuantity =
        typeof row.quantity === "number" && row.quantity > 0;
      const hasUnit = row.unit && row.unit.trim() !== "";

      return !hasMaterial || !validQuantity || !hasUnit;
    });

    if (invalidRows.length > 0) {
      invalidRows.forEach((row) => {
        setLoading(false);
        notification.error({
          message: "Hatalı Malzeme Satırı",
          description:
            row.name && row.name.trim() !== ""
              ? `${row.name} satırında eksik veya hatalı bilgi var.`
              : `Malzeme Adı belirtilmemiş satırda eksik veya hatalı bilgi var.`,
          placement: "topRight",
        });
      });
      return;
    }

    const payload = {
      ...values,
      desiredDeliveryDate: values.desiredDeliveryDate
        ? values.desiredDeliveryDate.format("YYYY-MM-DD")
        : null,
      purchaseRequestItemUpdateDtos: rows,
      documentVms: existingFiles,
    };
    const formData = new FormData();

    formData.append("jsonString", JSON.stringify(payload));
    files.forEach((file) => {
      formData.append("files", file.originFileObj);
    });

    RequestHandler.put(
      `/PurchaseRequest`,
      formData,
      true,
      {},
      "multipart/form-data",
    ).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onMaterialSearch = (value, record) => {
    if (value.length >= 2) {
      setMaterialsData({ data: [], loading: true });

      let filter = `${odata.contains("name", value)} or ${odata.contains("stockCode", value)}`;

      const deepestCatId =
        record?.cat5Id ||
        record?.cat4Id ||
        record?.cat3Id ||
        record?.cat2Id ||
        record?.cat1Id;

      if (deepestCatId && allCategories.length > 0) {
        const descendantIds = getDescendantIds(deepestCatId, allCategories);
        const catFilter = `materialCategoryId in (${descendantIds.map((id) => `'${id}'`).join(",")})`;
        filter = `(${filter}) and (${catFilter})`;
      }

      RequestHandler.get(
        `/Stock?$select=id,name,stockCode,unit,materialCategoryId,materialCategoryName&$filter=${filter}`,
      ).then((res) => {
        setMaterialsData({ data: res.value, loading: false });
      });
    } else {
      setMaterialsData({ data: [], loading: false });
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  const fileDownload = (file) => {
    window.open(
      `${config.apiUrl}/FileDownload/${file}?t=${RequestHandler.getToken()}`,
    );
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ data: [], loading: true });

      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value,
        )} or ${odata.contains("firmBranchNumber", value)}`,
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onChangeFirm = (value) => {
    if (value) {
      setFirmTransactionProjectTypeList({ data: [], loading: true });
      RequestHandler.get(
        `/FirmTransactionProjectType/GetListByFirmId/${value}`,
      ).then((res) => {
        setFirmTransactionProjectTypeList({ data: res, loading: false });
      });
      setFirmSelected(true);
    } else {
      setFirmTransactionProjectTypeList({ data: [], loading: false, data: [] });
      setFirmSelected(false);
    }
  };

  return (
    <>
      <Title level={3}>Talep Güncelleme</Title>

      <Form
        form={form}
        name="update-purchase-request"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row justify="center" style={{ padding: 20, paddingLeft: "20%" }}>
          <Col xs={24} md={20} lg={24}>
            <Form form={form} layout="vertical" onFinish={onFinish}>
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Row gutter={[16, 16]}>
                {/* Sol taraf */}
                <Col xs={24} md={18}>
                  <Card
                    title={
                      <span style={{ fontWeight: "bold", fontSize: 18 }}>
                        Talep Bilgileri
                      </span>
                    }
                    bordered={false}
                  >
                    <Form.Item
                      label="Talep Kodu :"
                      name="name"
                      rules={[
                        { required: true, message: "Lütfen kod giriniz" },
                      ]}
                    >
                      <Input disabled={isViewMode} />
                    </Form.Item>
                    <Form.Item
                      label="Talep Başlığı :"
                      name="description"
                    >
                      <Input.TextArea rows={3} disabled={isViewMode} />
                    </Form.Item>
                    <Form.Item label="Proje Adı/Ünvanı :" name="firmId">
                      <Select
                        showSearch
                        placeholder="En az 2 harf giriniz.."
                        onSearch={onFirmSearch}
                        filterOption={(input, option) =>
                          option.children
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                          option.code
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                        }
                        loading={firmSelect.loading}
                        disabled={isViewMode}
                        onChange={onChangeFirm}
                      >
                        {firmSelect.data.map((item) => (
                          <Select.Option
                            key={item.id}
                            value={item.id}
                            code={item.firmBranchNumber}
                          >
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label="Teslimat Deposu :"
                      name="transactionProjectTypeId"
                      rules={[
                        {
                          required: firmSelected,
                          message: "Lütfen teslimat deposu seçiniz.",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Teslimat Deposu"
                        allowClear
                        showSearch
                        filterOption={(input, option) =>
                          option.children
                            .toLocaleLowerCase("tr-TR")
                            .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                        }
                        loading={firmTransactionProjectTypeList.loading}
                      >
                        {firmTransactionProjectTypeList.data.map((item) => (
                          <Select.Option
                            key={item.transactionProjectTypeId}
                            value={item.transactionProjectTypeId}
                          >
                            {item.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label="İstenen Teslim Tarihi :"
                      name="desiredDeliveryDate"
                    >
                      <DatePicker
                        format="YYYY-MM-DD"
                        style={{ width: "30%" }}
                        disabledDate={(current) => {
                          return current && current < moment().startOf("day");
                        }}
                        disabled={isViewMode}
                      />
                    </Form.Item>
                    <Form.Item
                      label="Malzeme Alım Amacı ve Kullanilacağı Yer :"
                      name="purposeOfPurchasing"
                    >
                      <Input.TextArea rows={3} />
                    </Form.Item>
                  </Card>

                  <Card
                    title={
                      <span style={{ fontWeight: "bold", fontSize: 18 }}>
                        Talep Malzemeleri
                      </span>
                    }
                    bordered={false}
                    style={{ marginTop: 16 }}
                  >
                    <Button
                      type="dashed"
                      onClick={addRow}
                      icon={<PlusOutlined />}
                      style={{ marginBottom: 10 }}
                      disabled={isViewMode}
                    >
                      Satır Ekle
                    </Button>
                    <Table
                      columns={columns}
                      dataSource={rows}
                      pagination={false}
                      rowKey="key"
                      scroll={{ x: "max-content" }}
                    />

                    <br></br>
                    <br></br>
                    <Form.Item
                      label={
                        <span style={{ fontWeight: "bold" }}>
                          Malzeme Hakkında Açıklama, Teknik Detaylar ve Varsa
                          Marka Bilgileri :
                        </span>
                      }
                      name="detailedDescription"
                    >
                      <Input.TextArea rows={6} />
                    </Form.Item>
                  </Card>

                  {data?.statusByte == 0 && (
                    <Card
                      bordered
                      style={{ marginBottom: 24 }}
                      hidden={!(data?.statusByte == 0)}
                    >
                      <Title level={4}>BİRİNCİ ONAY (Depo Sorumlusu)</Title>
                      <Text strong>
                        Onaylayan Depo Sorumlusu:{" "}
                        {localStorage.getItem("userName")}
                      </Text>
                      <Form.Item
                        name="depoOnay"
                        valuePropName="checked"
                        rules={[
                          {
                            required: true,
                            message: "Lütfen onay kutularını işaretleyiniz.",
                          },
                        ]}
                      >
                        <Checkbox.Group
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 8,
                          }}
                        >
                          <br></br>
                          <Checkbox
                            value="noStockInDepot"
                            style={{ marginLeft: 0 }}
                          >
                            Talepte bulunulan malzemeler birimin depo
                            stoklarında yoktur
                          </Checkbox>
                          <br></br>
                          <Checkbox
                            value="noStockInOtherDepot"
                            style={{ marginLeft: 0 }}
                          >
                            Talepte bulunulan malzemeler {tenantName}'nin diğer
                            birim ve depolarından da sorulmuş ve oralarda da
                            olmadığı bilgisi alınmıştır.{" "}
                            <Text type="secondary">
                              (Not: Talep edilen malzeme diğer depolarda olduğu
                              halde getirme maliyeti daha yüksek olacaksa bu
                              kısım yine de onaylanmalıdır.)
                            </Text>
                          </Checkbox>
                        </Checkbox.Group>
                      </Form.Item>
                    </Card>
                  )}

                  <Card bordered hidden={!(data?.statusByte == 1)}>
                    <Title level={4}>
                      İKİNCİ ONAY (Birim/Şantiye Amiri/Yetkilisi)
                    </Title>
                    <Text strong>
                      Onaylayan Birim Yetkilisi:{" "}
                      {localStorage.getItem("userName")}
                    </Text>
                    <Form.Item name="approveUnit" valuePropName="checked">
                      <Checkbox.Group
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 8,
                        }}
                      >
                        <br></br>
                        <Checkbox value="needApprove">
                          Talepte bulunulan malzemeler birimin ihtiyaçları
                          dahilindedir. Miktarı ve kullanılacağı bildirilen yer
                          doğrudur.
                        </Checkbox>
                        <br></br>
                        <Checkbox
                          value="technicalDetailsCorrect"
                          style={{ marginLeft: 0 }}
                        >
                          Malzemeler için yazılan teknik detaylar (teknik
                          şartname) doğrudur.
                        </Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                  </Card>

                  <Card
                    title={
                      <span style={{ fontWeight: "bold", fontSize: 18 }}>
                        Dosyalar
                      </span>
                    }
                    bordered={false}
                    style={{ marginTop: 16 }}
                  >
                    {existingFiles.length > 0 && (
                      <div style={{ marginBottom: 16 }}>
                        {existingFiles.map((file) => (
                          <div
                            key={file.id}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              border: "1px solid #ddd",
                              padding: "8px 12px",
                              marginBottom: 8,
                              borderRadius: 4,
                            }}
                          >
                            <span>{file.fileName.split("\\").pop()}</span>
                            <div>
                              <Button
                                type="link"
                                onClick={() => fileDownload(file.fileName)}
                              >
                                İndir
                              </Button>
                              <Button
                                type="link"
                                danger
                                onClick={() =>
                                  setExistingFiles((prev) =>
                                    prev.filter((f) => f.id !== file.id),
                                  )
                                }
                                hidden={isViewMode}
                              >
                                Sil
                              </Button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    <Upload
                      multiple
                      beforeUpload={() => false}
                      onChange={({ fileList }) => setFiles(fileList)}
                      fileList={files}
                    >
                      <Button icon={<UploadOutlined />}>Dosya Yükle</Button>
                    </Upload>
                  </Card>

                  {!isViewMode && (
                    <Row justify="space-between">
                      <Col span={24} style={{ textAlign: "right" }}>
                        <Button
                          type="primary"
                          icon={<PlusOutlined />}
                          htmlType="submit"
                          loading={loading}
                        >
                          Güncelle
                        </Button>
                      </Col>
                    </Row>
                  )}
                </Col>
              </Row>

              {isViewMode && (
                <ApprovalButtons
                  entityId={data?.id}
                  entityType="purchaseRequest"
                  status={data?.statusByte}
                  canApprove={data?.canApprove}
                  canReject={data?.canReject}
                  canCancel={data?.canCancel}
                  isAdmin={data?.isAdmin}
                  onSuccess={onSuccess}
                  form={form}
                  documentVms={existingFiles}
                  files={files}
                />
              )}
            </Form>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default UpdatePurchaseRequest;
